/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import { CHANGE_USERNAME, ON_CALL_UPLOAD, ON_LOGIN_SUBMIT, ON_AUTH, ERROR_MSG, SET_FOOTER } from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  loginData: '',
  history: '',
  auth: false,
  errMsgVal: '',
  showFooter: true,
};

/* eslint-disable default-case, no-param-reassign */

  const loginReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case ON_LOGIN_SUBMIT:
        return {
          ...state,
          loginData:action.loginData,
          history:action.history
        }
      case ON_AUTH:
        return {
          ...state,
          auth:action.auth
        }
      case ERROR_MSG:
        return {
          ...state,
          errMsgVal:action.errMsgVal
        } 
      case SET_FOOTER:
        return {
          ...state,
          showFooter:action.showFooter
        } 
      default:
        return state;       
    }
  }

export default loginReducer;
